export default "__VITE_ASSET__84hZLbvd__"